import React, { Component } from "react";
import Button from "../../../../components/common/button/Button";
import styles from "./Confirmation.scss";
import { Form, FormGroup } from "react-bootstrap";
import { Link } from "react-router-dom";
import ScrollToTopOnMount from "./../../../../utils/scroll/ScrollToTopOnMount";

class Confirmation extends Component {
  render() {
    return (
      <section>
        <ScrollToTopOnMount />
        <section className={styles.confirmation}>
          <div className={styles.content}>
            <h2 className={styles.title}>Thank You!</h2>

            <Form onSubmit={this.props.handleSubmit}>
              <div className={styles.form}>
                <FormGroup>
                  <div className={styles.subtitle}>
                    Your endorsement for{" "}
                    {this.props.reference &&
                      this.props.reference.referenced_by.first_name}
                    &nbsp;
                    {this.props.reference &&
                      this.props.reference.referenced_by.last_name}{" "}
                    has been submitted to our team for review.
                  </div>

                  <div className={styles.dividerDouble} />

                  <div className={styles.CTATitle}>
                    Work with The Second Shift
                  </div>

                  <p className={styles.CTASubtitle}>
                    The Second Shift is a marketplace for professional women
                    seeking short-term projects and flexible work arrangements.
                    We have placed hundreds of women in high-level senior
                    positions to the delight of our customers.
                  </p>
                  <br />
                  <p className={styles.CTASubtitle}>
                    Becoming a Company on The Second Shift is free to start. Get
                    started below, and a member of The Second Shift team will be
                    in touch to help you create your first project.
                  </p>
                </FormGroup>

                <div className={styles.CTAContainer}>
                  <Link to="/company/sign-up">
                    <Button
                      isPrimary
                      isSmall
                      type="submit"
                      size={"large"}
                      label="Get Started"
                    />
                  </Link>
                </div>
              </div>
            </Form>
          </div>
        </section>
      </section>
    );
  }
}

export default Confirmation;



// WEBPACK FOOTER //
// ./src/routes/admin/reference/components/Confirmation.js